import { PropsWithChildren } from 'react'

import styles from './Status.module.scss'

export type StatusType = 'active' | 'error' | 'inactive' | 'normal' | 'draft' | 'purple' | 'pending'

interface StatusProps extends PropsWithChildren {
  status: StatusType
}

const Status = ({ children, status }: StatusProps) => (
  <div className={styles.status} data-testid="status" {...{ status }}>
    {children}
  </div>
)

export default Status
